// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_wYL","cls2":"common-cls2_cCB common-cls1_wYL","noClick":"common-noClick_eWZ"};